/**
 * Created by Andrey Popov on 02.10.2026
 */

const EditorMap2dBoundsView = cc.Node.extend({
    ctor: function (editor, mapView) {
        this._super();

        this.editor = editor;
        this.mapView = mapView;

        this.setAnchorPoint(0, 0);
        this.setContentSize2(mapView.width, mapView.height);

        editor.on("changeBoundsMode", this.onChangeMode.bind(this), this);
        editor.map.on("changeScrollBounds", this.redraw.bind(this), this);

        this.onChangeMode(editor.boundsMode);
    },

    onChangeMode: function (active) {
        this.setVisible(Boolean(active));

        if (active) {
            this.showFrame();
            this.redraw();
            this.startEditing();

            const boxes = this.editor.map.visibleBoxes;
            if (boxes && boxes.length > 1) {
                cleverapps.notification.create(`The map has ${boxes.length} scroll bounds, the last one is edited`);
            }
        } else {
            this.stopEditing();
        }
    },

    // zooms out until the whole frame is on the screen
    showFrame: function () {
        const scroll = this.editor.map.scroller.getScrollView();
        const rect = this.getRect();
        const visible = scroll.getVisibleRect();

        const fit = EditorMap2dBoundsView.FIT * Math.min(visible.width / rect.width, visible.height / rect.height);
        if (fit < 1) {
            scroll.zoomHandler.setZoom(scroll.zoom * fit);
        }
        scroll.scrollTo(cc.p(rect.x + rect.width / 2, rect.y + rect.height / 2));
    },

    getRect: function () {
        const map = this.editor.map;
        const bounds = map.scrollBounds;
        const cell = cleverapps.styles.Map2dView.cell;
        const size = map.getWidth() + map.getHeight();
        const totalWidth = size * cell.width / 2;
        const totalHeight = size * cell.height / 2;

        const left = totalWidth * bounds.cutLeft - this.mapView.cutLeft;
        const right = totalWidth * (1 - bounds.cutRight) - this.mapView.cutLeft;
        const bottom = totalHeight * bounds.cutBottom - this.mapView.cutBottom;
        const top = totalHeight * (1 - bounds.cutTop) - this.mapView.cutBottom;

        return cc.rect(left, bottom, right - left, top - bottom);
    },

    redraw: function () {
        if (this.frame) {
            this.frame.removeFromParent();
            this.frame = undefined;
        }

        if (!this.editor.boundsMode) {
            return;
        }

        const styles = cleverapps.styles.EditorMap2dBoundsView;
        const rect = this.getRect();
        const scale = this.editor.map.scroller.getScrollView().centerNode.getScale();

        this.frame = new cc.DrawNode();
        this.frame.drawRect(
            cc.p(rect.x, rect.y),
            cc.p(rect.x + rect.width, rect.y + rect.height),
            cc.color(0, 0, 0, 0),
            styles.lineWidth / scale,
            cc.color(255, 0, 0, 255)
        );
        this.addChild(this.frame);
    },

    startEditing: function () {
        if (this.keyboardListener) {
            return;
        }

        this.keyboardListener = cleverapps.inputDispatcher.on("keypressed", (key) => {
            const side = EditorMap2dBoundsView.SIDES[key];
            if (!side) {
                return;
            }

            const narrower = cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.shift);
            const bounds = { ...this.editor.map.scrollBounds };
            bounds[side] = +(bounds[side] + (narrower ? 1 : -1) * EditorMap2dBoundsView.STEP).toFixed(2);

            const width = 1 - bounds.cutLeft - bounds.cutRight;
            const height = 1 - bounds.cutTop - bounds.cutBottom;
            if (width < EditorMap2dBoundsView.MIN_SIZE || height < EditorMap2dBoundsView.MIN_SIZE) {
                return;
            }

            this.editor.doCommand("setScrollBounds", bounds);
        }, this);
    },

    stopEditing: function () {
        if (this.keyboardListener) {
            this.keyboardListener.clear();
            delete this.keyboardListener;
        }
    }
});

EditorMap2dBoundsView.STEP = 0.01;
EditorMap2dBoundsView.MIN_SIZE = 0.05;
// the part of the screen the frame takes after the zoom out
EditorMap2dBoundsView.FIT = 0.9;

EditorMap2dBoundsView.SIDES = {
    [InputDispatcher.KEY.left]: "cutLeft",
    [InputDispatcher.KEY.right]: "cutRight",
    [InputDispatcher.KEY.up]: "cutTop",
    [InputDispatcher.KEY.down]: "cutBottom"
};

cleverapps.styles.EditorMap2dBoundsView = {
    lineWidth: 8
};
